import { createContext, useContext } from 'react';

import type { ChatContentProps } from '../components/chat-content';

export const NovaChatContentOptionsContext = createContext<ChatContentProps>({});
export function useNovaChatContentOptions() {
  return useContext(NovaChatContentOptionsContext);
}
